module.exports = {
  content: {
    personalInformation: "My Profile",
    myMessage: "My Message",
    myOrder: "My Orders",
    myQuestionAndAnswer: "My Q&A",
    saleOrder: "Refund Orders",
    myComment: "My Evaluation",
    shippingAddress: "Delivery Address",
    couponPackage: "Coupon Package",
    changePassword: "Change Password",
    changePhoneNumber: "Change Phone Number",
    myCollection: "My Collection",
    browseFootprint: "Browse Footprint",
    unbindPhone: "Unbind Phone",
    customerService: "Customer Service",
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en-us/userCenter/menu.js